import { styled } from 'styled-system/jsx'

const Track = styled('button', {
  base: {
    width: '46px',
    height: '26px',
    borderRadius: 'pill',
    border: 'none',
    cursor: 'pointer',
    position: 'relative',
    backgroundColor: '#E5E0F5',
    transition: 'background-color {durations.fast} {easings.appleStandard}',
    flexShrink: '0',
    _disabled: {
      cursor: 'not-allowed',
      opacity: '0.5',
    },
  },
  variants: {
    isOn: {
      true: { backgroundColor: 'quickpass.primary' },
    },
  },
})

const Knob = styled('span', {
  base: {
    position: 'absolute',
    top: '3px',
    left: '3px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.18)',
    transition: 'transform {durations.fast} {easings.appleStandard}',
  },
  variants: {
    isOn: {
      true: { transform: 'translateX(20px)' },
    },
  },
})

export { Track, Knob }
